export function match(value) {
  return /.*\..*/.test(value);
}
